import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import MTCCustomIconComponent from '@mtc/mtc-custom-icon/mtc-custom-icon.component';

@Component({
  selector: 'app-back-button',
  imports: [MTCCustomIconComponent],
  templateUrl: './back-button.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: ``,
})
export default class BackButtonComponent {
  text = input('Back');
}
